import * as React from 'react'

function SvgNotAdminPlaceHoldersvg(props) {
  return (
    <svg
      width="6em"
      // height="1em"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53.152 96h-11.25a2.812 2.812 0 01-2.792-2.471l-.77-6.306a40.02 40.02 0 01-6.43-2.096l-4.335 4.653a2.812 2.812 0 01-3.71.359l-9.102-6.613a2.813 2.813 0 01-.806-3.64l3.082-5.553a40.428 40.428 0 01-4-5.47l-6.211 1.21a2.812 2.812 0 01-3.213-1.89l-3.477-10.7a2.812 2.812 0 011.488-3.419l5.757-2.68A35.654 35.654 0 017.215 48c0-1.077.054-2.182.168-3.384l-5.757-2.68a2.813 2.813 0 01-1.488-3.42l3.477-10.698a2.813 2.813 0 013.213-1.892l6.21 1.211a40.446 40.446 0 014.001-5.47l-3.082-5.553a2.813 2.813 0 01.806-3.64l9.101-6.613a2.812 2.812 0 013.711.358l4.334 4.653a40.008 40.008 0 016.43-2.095l.771-6.306A2.813 2.813 0 0141.902 0h11.25c1.422 0 2.62 1.06 2.792 2.471l.77 6.306a40.027 40.027 0 016.43 2.096L67.48 6.22a2.812 2.812 0 013.711-.359l9.101 6.613a2.812 2.812 0 01.806 3.64l-3.082 5.553a40.417 40.417 0 014 5.47l6.211-1.21a2.812 2.812 0 013.213 1.89l3.477 10.7a2.812 2.812 0 01-1.488 3.42l-5.757 2.68A35.59 35.59 0 0187.84 48c0 1.077-.055 2.182-.168 3.384l5.756 2.68a2.813 2.813 0 011.488 3.42L91.44 68.182a2.812 2.812 0 01-3.214 1.891l-6.21-1.211a40.446 40.446 0 01-4.001 5.47l3.082 5.553a2.813 2.813 0 01-.805 3.64L71.19 90.14a2.812 2.812 0 01-3.711-.358l-4.334-4.653a40.01 40.01 0 01-6.43 2.095l-.771 6.306A2.813 2.813 0 0153.152 96z"
        fill="#8989A5"
      />
      <path
        d="M55.944 93.529l.77-6.306a39.997 39.997 0 006.431-2.096l4.334 4.653a2.812 2.812 0 003.711.359l9.102-6.613a2.812 2.812 0 00.805-3.64l-3.082-5.553a40.403 40.403 0 004-5.47l6.212 1.21a2.813 2.813 0 003.213-1.89l3.476-10.7a2.812 2.812 0 00-1.488-3.42l-5.756-2.68c.114-1.2.168-2.306.168-3.383s-.055-2.182-.168-3.384l5.757-2.68a2.813 2.813 0 001.487-3.42L91.44 27.819a2.812 2.812 0 00-3.213-1.892l-6.211 1.211a40.437 40.437 0 00-4-5.47l3.082-5.553a2.813 2.813 0 00-.806-3.64L71.19 5.86a2.812 2.812 0 00-3.71.358l-4.335 4.653a40.026 40.026 0 00-6.43-2.095l-.77-6.306A2.813 2.813 0 0053.151 0h-5.625v96h5.625c1.422 0 2.62-1.06 2.792-2.471z"
        fill="#616173"
      />
      <path
        d="M47.527 72.375c13.462 0 24.375-10.913 24.375-24.375S60.99 23.625 47.527 23.625 23.152 34.538 23.152 48s10.913 24.375 24.375 24.375z"
        fill="#FFF5F5"
      />
      <path
        d="M71.902 48c0-13.462-10.913-24.375-24.375-24.375v48.75c13.462 0 24.375-10.913 24.375-24.375z"
        fill="#E2DFF4"
      />
      <path
        d="M51.277 50.813h-7.5c-7.754 0-14.062 6.308-14.062 14.062v2.311l17.812 5.751 17.813-5.75v-2.312c0-7.754-6.309-14.063-14.063-14.063z"
        fill="#FCB67E"
      />
      <path
        d="M51.277 50.813h-3.75v22.124l17.813-5.75v-2.312c0-7.754-6.309-14.063-14.063-14.063z"
        fill="#E97313"
      />
      <path
        d="M47.527 75.188C32.537 75.188 20.34 62.99 20.34 48s12.196-27.188 27.187-27.188C62.52 20.813 74.715 33.01 74.715 48S62.518 75.188 47.527 75.188zm0-48.75c-11.89 0-21.562 9.672-21.562 21.562s9.673 21.563 21.562 21.563c11.89 0 21.563-9.673 21.563-21.563 0-11.89-9.673-21.563-21.563-21.563z"
        fill="#616173"
      />
      <path
        d="M69.09 48c0 11.89-9.673 21.563-21.563 21.563v5.624c14.992 0 27.188-12.196 27.188-27.187 0-14.991-12.197-27.188-27.188-27.188v5.625c11.89 0 21.563 9.673 21.563 21.563z"
        fill="#403B40"
      />
      <path
        d="M47.527 53.625c-4.91 0-8.906-3.995-8.906-8.906v-3.75c0-4.911 3.995-8.907 8.906-8.907 4.911 0 8.907 3.996 8.907 8.907v3.75c0 4.91-3.996 8.906-8.907 8.906z"
        fill="#FFDECF"
      />
      <path
        d="M56.434 44.719v-3.75c0-4.911-3.996-8.907-8.907-8.907v21.563c4.911 0 8.907-3.995 8.907-8.906z"
        fill="#FFCDBE"
      />
    </svg>
  )
}

export default SvgNotAdminPlaceHoldersvg
